import React from "react";
import { Link } from "react-router-dom";

import { USEFUL_SERVICE_CATEGORIES } from "../data/usefulServices";
import { useI18n } from "../i18n";
import { trackUsefulServiceEvent } from "../lib/usefulServicesAnalytics";

export default function UsefulServicesPanel() {
  const { t } = useI18n();

  return (
    <section className="mt-8 rounded-[32px] border border-cyan-300/25 bg-black/55 p-5 shadow-[0_0_45px_rgba(0,245,255,0.12)] backdrop-blur-2xl md:p-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.26em] text-cyan-300">
            {t("services.homeEyebrow")}
          </p>
          <h2 className="mt-2 text-2xl font-black text-white md:text-3xl">
            {t("services.homeTitle")}
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-white/60">
            {t("services.homeIntro")}
          </p>
        </div>

        <Link
          to="/useful-services"
          onClick={() =>
            trackUsefulServiceEvent("useful_service_click", {
              service_id: "overview",
              service_label: "Useful Services",
              service_type: "overview",
              destination: "Benalmádena",
              action: "open_overview",
              page_path: "/",
            })
          }
          className="inline-flex shrink-0 items-center justify-center rounded-2xl border border-cyan-300/35 bg-cyan-300/10 px-4 py-3 text-sm font-black text-cyan-100 transition hover:border-cyan-200/60 hover:bg-cyan-300/15"
        >
          {t("actions.viewAllServices")}
        </Link>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {USEFUL_SERVICE_CATEGORIES.map((service) => (
          <Link
            key={service.id}
            to={service.path}
            onClick={() =>
              trackUsefulServiceEvent("useful_service_click", {
                service_id: service.id,
                service_label: service.label,
                service_type: service.id,
                destination: service.destination,
                action: "homepage_card_click",
                page_path: "/",
              })
            }
            className="group rounded-2xl border border-white/10 bg-white/[0.04] px-3 py-4 text-center transition hover:-translate-y-0.5 hover:border-fuchsia-400/40 hover:bg-fuchsia-500/10"
          >
            <span className="block text-2xl" aria-hidden="true">
              {service.icon}
            </span>
            <span className="mt-2 block text-xs font-black uppercase tracking-[0.12em] text-white/75 group-hover:text-white">
              {t(`services.${service.id}`) || service.shortLabel}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
